import React, { memo } from 'react'
import useFetch from '@alobato/use-fetch'
import CircularProgress from '@alobato/circular-progress'
import { Formik } from 'formik'
import * as Yup from 'yup'
import '../../validators'

import FormModal from '../../components/FormModal'
import Form from './Form'
import useCatalogos from '../../hooks/useCatalogos'
import { enviarCadastro } from '../../lib/enviarCadastro'

import AUTH_TOKEN from '../../constants/authToken'
import BASE_API from '../../constants/baseApi'

const validationSchema = Yup.object().shape({
  name: Yup.string().required(),
  comercial_email: Yup.string().email('E-mail inválido'),
  website: Yup.string().url('Endereço inválido — comece com https://')
})

const Edit = memo(({ id, data, onRequestClose, onUpdated, especialidades, planos }) => {
  const initialValues = {
    name: data.name || '',
    login: data.login || '',
    password: '',
    comercial_email: data.comercial_email || '',
    phone: data.phone || '',
    whatsapp: data.whatsapp || '',
    website: data.website || '',
    working_time: data.working_time || '',
    small_description: data.small_description || '',
    description: data.description || '',
    has_exam: !!data.has_exam,
    has_schedule: !!data.has_schedule,
    has_schedule_exam: !!data.has_schedule_exam,
    need_login: !!data.need_login,
    visible: !!data.visible,
    specialties: data.specialty_ids || [],
    health_insurances: data.health_insurances || []
  }

  const handleSubmit = async (values, actions) => {
    const salvou = await enviarCadastro({
      url: `${BASE_API}/establishment?id=${id}`, method: 'PUT', values, actions
    })
    if (!salvou) return
    onUpdated()
    onRequestClose()
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={validationSchema}
      validateOnChange={false}
      render={props => (
        <FormModal title='Editar Estabelecimento' onRequestClose={onRequestClose}
          onSubmit={props.handleSubmit} submitting={props.isSubmitting} error={props.status}>
          <Form {...props} especialidades={especialidades} planos={planos} />
        </FormModal>
      )}
    />
  )
})

export default memo(props => {
  const { data, error, loading } = useFetch(
    `${BASE_API}/establishment?id=${props.id}`,
    { headers: { Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}` } }
  )
  const catalogos = useCatalogos()

  if (error) return `Erro! ${error.message}`
  if (!data || loading || catalogos.carregando) {
    return <CircularProgress color='hsla(199, 75%, 43%, 1)' />
  }
  return (
    <Edit {...props} data={data}
      especialidades={catalogos.especialidades} planos={catalogos.planos} />
  )
})
